import styled from 'styled-components'
import { ChangeOwnerContainer } from './ChangeOwnerContainer'

export const ChangeOwnerContainerUI = styled(ChangeOwnerContainer)`
  width: calc(100% - 2em);
`
